export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/astrology_psychics.bf2214c.svg";